var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-tab-view',{staticStyle:{"padding":"0.3em"},attrs:{"sidebar":"","tabs":_vm.tabs}})}
var staticRenderFns = []

export { render, staticRenderFns }